// Lane → certification-tab mapping for the Section 2
// Additional Certifications surface (A2 / A3 / A4 analyst tabs).
//
// The per-lane cert universe (titles, blurbs, prose) is no longer a frontend
// static array — it lives in the DB UnderwritingCertificationTemplate table and
// is admin-editable. Fetch it via useCertificationTemplatesByLane. This file
// keeps only the pure lane → DealFlowTab mapping that several call sites share.

import type { CriteriaLane, DealFlowTab } from "@/api/dealFlow/types";

/** Map analyst lane → cert tab identifier expected by the certifications +
 *  certification-template endpoints. Section is always 2 for Additional
 *  Certifications; A1 has no Section 2 surface (it maps to Underwriting, which
 *  the template endpoint returns empty for). */
export function tabForAnalystLane(lane: CriteriaLane): DealFlowTab {
  switch (lane) {
    case "A2":
      return "FinancialAnalysis";
    case "A3":
      return "LegalAnalysis";
    case "A4":
      return "BusinessAnalysis";
    case "A1":
    default:
      return "Underwriting";
  }
}
